﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { Funding } from '../../../viewmodel';
import { Animations } from '../../common/animations';
import { AppConfig } from '../../../app.config';

@Component({
    selector: 'app-publicfunding',
    templateUrl: './publicfunding.component.html',
    providers: [InformationService, BuildingService],
    animations: [Animations.flyInOut]
})
export class PublicFundingComponent implements OnInit {

    public floornumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    public unitsnumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    public ZR23Url: string = AppConfig.config.ZR23Url;
    animate: string = 'active';
    animateClass = 'slideInRight';
    previousUrl: string = ''; 
    title: string = 'Public Funding';
    questionType: number = 416; 
    projectId: number = 0;    
    devProjectBuildingId: number = 0;
    siteProjectBuildingId: number = 0;
    projBuildingId: number = 0;
    buildingId: number = 0;

    entityId: number = 0;
    buildingAddress: string = '';
    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false; 
    submitted: boolean = false;    
    questionForm: FormGroup;
    model: Funding;
    showOther: boolean = false;

    constructor(private router: Router 
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService) {

        this.model = new Funding();
        //this.model.ProjectId = this.projectId; 
    }

    ngOnInit() {
        this.animateClass = 'slideInLeft';
        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjectBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjectBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            this.projBuildingId = this.devProjectBuildingId == null ? this.siteProjectBuildingId : this.devProjectBuildingId;
            if (bqp.buildingAddress != null || bqp.buildingAddress == '')
                this.buildingAddress = '- ' + bqp.buildingAddress;
        }
        else {
            this.sharedService.navigateSummary();
        }
        if (this.projBuildingId == null || this.buildingId == null)
            this.sharedService.navigateSummary();

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
            this.sharedService.navigateHome();
        }

        this.questionForm = this.frmBuilder.group({
            pubicFunding: ['', Validators.required],
            city: [null], 
            state: [null], 
            federal: [null], 
            cityHpd: [null],
            cityHdc: [null],
            cityOther: [null],
            subsidyDesc: ['', Validators.required]          
        });        

        this.informationService.GetProjectBuildingPublicFunding(this.devProjectBuildingId, this.siteProjectBuildingId)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {                       
                        if (success.Result.IsValid)
                            this.isEdit = true; 

                        this.PopulateData(success.Result);
                    }

                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })
         
    }

    PopulateData(building) {
        if (building == null || building.length == 0)
            return false;

        if (building.HasPublicFunding)
            this.model.HasPublicFunding = 'true';
        else
            this.model.HasPublicFunding = 'false';

        this.model.HasCitySourceCategory = building.HasCitySourceCategory;
        this.model.HasStateSourceCategory = building.HasStateSourceCategory;
        this.model.HasFederalSourceCategory = building.HasFederalSourceCategory;

        this.model.HasHPDCitySubsidy = building.HasHPDCitySubsidy;
        this.model.HasHDCCitySubsidy = building.HasHDCCitySubsidy;
        this.model.HasOtherCitySubsidy = building.HasOtherCitySubsidy;
        this.model.OtherCitySubsidySourceName = building.OtherCitySubsidySourceName; 
    }


    changePublicFunction() {
        if (this.model.HasPublicFunding == 'false') {
            this.model.HasCitySourceCategory = this.model.HasStateSourceCategory = this.model.HasFederalSourceCategory = false;
            this.model.HasHPDCitySubsidy = this.model.HasHDCCitySubsidy = this.model.HasOtherCitySubsidy = false; 
            this.model.OtherCitySubsidySourceName = ''; 
        } 
    }

    changeCity() {
        if (!this.model.HasCitySourceCategory) {
            this.model.HasHPDCitySubsidy = this.model.HasHDCCitySubsidy = this.model.HasOtherCitySubsidy = false;
            this.model.OtherCitySubsidySourceName = '';
        }  
    }

    changeOther() {
        if (!this.model.HasOtherCitySubsidy) 
            this.model.OtherCitySubsidySourceName = '';
    }

    save(button) {

        this.submitted = true;

        if (this.model.HasOtherCitySubsidy == true && this.model.OtherCitySubsidySourceName != null)
            this.model.OtherCitySubsidySourceName = this.model.OtherCitySubsidySourceName.trim();

        if ((this.model.HasPublicFunding == null)
            || (this.model.HasPublicFunding == 'true' && ((this.model.HasCitySourceCategory == false || this.model.HasCitySourceCategory == null) && (this.model.HasStateSourceCategory == false || this.model.HasStateSourceCategory == null) && (this.model.HasFederalSourceCategory == false || this.model.HasFederalSourceCategory == null)))
            || (this.model.HasCitySourceCategory == true && ((this.model.HasHPDCitySubsidy == false || this.model.HasHPDCitySubsidy == null) && (this.model.HasHDCCitySubsidy == false || this.model.HasHDCCitySubsidy == null) && (this.model.HasOtherCitySubsidy == false || this.model.HasOtherCitySubsidy == null)))
            || ((this.model.HasOtherCitySubsidy == true && (this.model.OtherCitySubsidySourceName == '' || this.model.OtherCitySubsidySourceName == null)))) {
            return false;
        }

        this.model.IsValid = true;
        this.informationService.SaveProjectBuildingPublicFunding(this.model)
            .subscribe(
            success => {
                if (!success.Success){ 
                    this.showError(success.StatusMessage);
				}
                else {
                    if (button == 'NEXT') {
                        this.router.navigate(["/buildings/buildingtype"]);
                    }
                    else if (button == 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }

    previous() {
        this.router.navigate(["/buildings/unitcount"]);
    }

    home() {
        this.sharedService.navigateHome();
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    validateSourceCategories()
    {
        return (((this.model.HasCitySourceCategory == null || this.model.HasCitySourceCategory == false) &&
            (this.model.HasStateSourceCategory == null || this.model.HasStateSourceCategory == false) &&
            (this.model.HasFederalSourceCategory == null || this.model.HasFederalSourceCategory == false))
            && this.submitted);
    }

    validateSourceofCitySubsidy()
    {
        return (((this.model.HasHPDCitySubsidy == null || this.model.HasHPDCitySubsidy == false) &&
            (this.model.HasHDCCitySubsidy == null || this.model.HasHDCCitySubsidy == false) &&
            (this.model.HasOtherCitySubsidy == null || this.model.HasOtherCitySubsidy == false)) && this.submitted);
    }

    needCitySubsidyOther()
    {
        return this.model.HasOtherCitySubsidy && this.model.HasCitySourceCategory && this.model.HasPublicFunding == 'true';
    }
}
